import { useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";

//
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";

import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { is } from "src/util/is";
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
  backgroundColor: theme.palette.background.default,
}));

const MainStyle = styled("div")(({ theme, isCollapsed }) => {
  const isLight = theme.palette.mode === "light";
  return {
    flexGrow: 1,
    overflow: "auto",
    minHeight: "100%",
    backgroundColor: theme.palette.background.default,
    backgroundImage: isLight ? theme.palette.gradients.dashboardCanvas : "none",
    backgroundAttachment: isLight ? "fixed" : "initial",
    backgroundSize: "cover",
    backgroundPosition: "center",
    paddingTop: APP_BAR_MOBILE + 10,
    paddingBottom: theme.spacing(10),
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up("lg")]: {
      paddingTop: APP_BAR_DESKTOP + 10,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      marginLeft: 0, // Remove the margin
      width: isCollapsed ? `calc(100% - 110px)` : `calc(100% - 250px)`,
    },
  };
});

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const team = useSelectedTeam();

  /**
   * First thing to call after login or page refresh
   * This function will check if JWT token is set or not
   * If not it will redirect user to login
   * If yes, fetch JWT token from local storage and parse it. set userId to state
   */
  // useEffect(() => {
  //   const userData = Token.parsedToken();
  //   if (userData && userData.success && userData.data) {
  //     setUsername(userData.data.username);
  //     setUserId(userData.data._id);
  //   } else {
  //     navigate("/login");
  //   }
  // }, []);

  /**
   * First thing to call after login or page refresh
   * return axios.get("/user/getUserDetail", {
      params: {
        username: userData.data.username
      }
   */
  // useEffect(() => {
  //   if (!username) {
  //     return;
  //   }
  //   (async function () {
  //     try {
  //       const getUserDetail = async () => {
  //         const response = await axios(
  //           `${process.env.REACT_APP_SERVER_URL}user/${userId}`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${Token.get()}`,
  //             },
  //           }
  //         );
  //         const userDetailRes = response.data.data;
  //         if (userDetailRes) {
  //           setUserDetail(userDetailRes);
  //         }
  //       };

  //       await getUserDetail();
  //     } catch (error) {
  //       console.error(error.response);
  //       navigate("/login");
  //     }
  //   })();
  // }, [username]);

  // useEffect(() => {
  //   if (userDetail && userDetail._id) {
  //     setIsAuthenticated(true);
  //   }
  // }, [userDetail]);
  return (
    <RootStyle>
      <DashboardNavbar 
        onOpenSidebar={() => setOpen(true)} 
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setIsCollapsed(!isCollapsed)}
      />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
        isCollapsed={isCollapsed}
      />
      <MainStyle isCollapsed={isCollapsed}>{!is.empty(team) && <Outlet />}</MainStyle>
    </RootStyle>
  );
}
